<template>
	<div class="content">
		<div class="service-box flex-col">
			<p class="title">无忧用电</p>
			<div class="cont-box">
				<div v-for="(item,index) in list" :key="index" class="msg" :class="item.remark">
<!--					<img class="avatar" src="../../assets/image/avatar.png" />-->
<!--					<p class="text">{{item.content}}</p>-->

					<img v-if="item.remark==='left'" class="avatar" src="../../assets/image/avatar.png" />
					<p class="text">{{ item.content }}</p>
					<img v-if="item.remark==='right'" class="avatar" src="../../assets/image/avatar.png" />
				</div>
			</div>
			<div class="input-box">
				<textarea v-model="content" placeholder="请描述你的问题"></textarea>
				<button @click="addHandle">发送</button>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		contactListApi,
		contactAddApi,
		contactFactoryAndElecListApi
	} from '../../http/api/user.js'
	export default {
		data() {
			return {
				sessionId: null,
				list: [],
				content: ''
			}
		},
		created() {
			this.getList()
		},
		methods: {
			getList() {
				if (this.$route.query.sessionId) {
					contactFactoryAndElecListApi({
						sessionId: this.$route.query.sessionId
					}).then(res => {
						this.list = res.contents;
						this.sessionId = res.sessionId;
						this.$nextTick(function() {
							let scrollRef = this.$refs.scroll;
							scrollRef.scrollTo({
								top: scrollRef.scrollHeight + 40,
								behavior: "smooth",
							});
						});
					})
				} else {
					contactListApi({
						contactType: this.$route.query.contactType || 0,
						contactId: this.$route.query.contactId || 1,
					}).then((res) => {
						this.list = res.contents;
						this.sessionId = res.sessionId;
						this.$nextTick(function() {
							let scrollRef = this.$refs.scroll;
							scrollRef.scrollTo({
								top: scrollRef.scrollHeight + 40,
								behavior: "smooth",
							});
						});
					});
				}
			},
			back() {
				this.$router.push({
					path: "/ordinaryUser/index",
				})
			},
			addHandle() {
				if (this.content == '') {
					return
				}
				contactAddApi({
					pid: this.sessionId,
					content: this.content
				}).then(res => {
					this.getList()
					this.content = ''
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.content {
		width: 100%;
		height: 100%;
		background-color: #babbbf;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 10px;

		.back {
			position: fixed;
			top: 20px;
			left: 60px;
			width: 120px;
			height: 35px;
			border-radius: 20px;
			background-color: #ffffff;
			font-size: 14px;
			line-height: 35px;
			color: #000000;
			text-align: center;
		}

		.service-box {
			width: 50%;
			min-width: 500px;
			background: #ffffff;
			border-radius: 8px;
			height: 80%;

			.title {
				font-size: 12px;
				color: #ffffff;
				height: 34px;
				line-height: 34px;
				background-color: #ff8b50;
				padding: 0 15px;
				border-radius: 8px 8px 0 0;
			}

			.cont-box {
				flex: 1;
				overflow-y: scroll;
				padding: 20px 10px;
				background-color: #f2f0f1;

				&::-webkit-scrollbar {
					width: 4px;
					height: 4px;
				}

				&::-webkit-scrollbar-thumb {
					border-radius: 2px;
					-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
					background: rgba(0, 0, 0, 0.1);
				}

				&::-webkit-scrollbar-track {
					-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
					border-radius: 0;
				}

				.msg {
					width: 100%;
					display: flex;
					margin-bottom: 10px;
				}

				.right {
					justify-content: flex-end;
				}

				.avatar {
					width: 36px;
					height: 36px;
					border-radius: 50%;
					margin: 0 10px;
				}

				.text {
					border-radius: 4px;
					background-color: #ffffff;
					padding: 10px 15px;
					font-size: 12px;
					line-height: 16px;
				}
			}

			.input-box {
				width: 100%;
				height: 150px;
				background-color: #ffffff;
				position: relative;

				textarea {
					width: calc(100% - 40px);
					height: 100px;
					border: none;
					outline: none;
					resize: none;
					padding: 10px 20px;
				}

				button {
					position: absolute;
					bottom: 20px;
					right: 20px;
					width: 80px;
					height: 28px;
					border-radius: 4px;
					background-color: #fe8a51;
					border: none;
					font-size: 12px;
					color: #ffffff;
					line-height: 28px;
				}
			}
		}
	}
</style>
